module.exports = __webpack_public_path__ + "static/media/alert_environnement.1a08bd00.png";